// How many trainings a calendar session counts as: one training lasts up to
// 60 minutes, so a 2-hour block is 2 and 3 hours is 3 (odd lengths round to
// the nearest hour). Mirrors backend/session_units.py; computed from the
// times so Google Calendar events without a `units` field work too.
export const sessionUnits = (s) => {
  if (s && Number.isInteger(s.units)) return s.units;
  const minutes = (new Date(s.end_time) - new Date(s.start_time)) / 60000;
  return Number.isFinite(minutes) ? Math.max(1, Math.floor(minutes / 60 + 0.5)) : 1;
};

export const sumUnits = (list) => list.reduce((n, s) => n + sessionUnits(s), 0);

export const unitsLabel = (n) => (n === 1 ? '1 trening' : n < 5 ? `${n} treningi` : `${n} treningów`);
